<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">审查调查></span>
        <span @click="GoreportEvaluation">党纪政务处分></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>中信银行股份有限公司原党委副书记、行长孙德顺严重违纪违法被开除党籍</h1>
         <div class="first">
        <span class="third">来源：新华社</span>
          <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
       <div class="xh"></div>
        <h3 class="yi">日前，中央纪委国家监委对中信银行股份有限公司原党委副书记、行长孙德顺严重违纪违法问题进行了立案审查调查。</h3>
        <h3>经查，孙德顺丧失理想信念，毫无政治意识和大局意识，严重违背党中央关于金融服务实体经济的决策部署，限制、压降制造业贷款；违反中央八项规定精神，违规向贷款客户借用房产，由他人支付应由其本人承担的费用；不按规定报告个人有关事项，在职工录用中违规为他人谋取利益；价值观极度扭曲，既想当官又想发财，违规经商办企业，为本人及亲友攫取巨额利益；贪欲极度膨胀，把贷款审批权力作为谋取个人利益的筹码，与不法商人勾肩搭背，大搞权钱交易，在贷款授信、审批等方面利用职务上的便利为他人谋利，并非法收受巨额财物。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>孙德顺严重违反党的政治纪律、组织纪律、廉洁纪律、工作纪律和生活纪律，构成严重职务违法并涉嫌受贿犯罪，且在党的十八大后不收敛不收手，系金融领域腐败问题特别严重、性质特别恶劣、数额特别巨大的典型，应予严肃处理。依据《中国共产党纪律处分条例》《中华人民共和国监察法》等有关规定，经中央纪委常委会会议研究，决定给予孙德顺开除党籍处分；按规定取消其享受的待遇；收缴其违纪违法所得；将其涉嫌犯罪问题移送检察机关依法审查起诉，所涉财物随案移送。-2018年在担任该所党支部书记、所长期间，违反中央八项规定精神、违反政治纪律、挪用公款、非法占有公共财物等，被群众多次举报。其中违反中央八项规定精神达3次之多，从党内警告处分直至给予留党察看。分析多次被举报受处分人员情况，国家工作人员71人，农村党员干部108人。其中村（社区）主职干部被举报频率较高，受处分达72人，占比40.22%。</h3>
        <h3>
          <b>孙德顺简历</b>
        </h3>
        <h3>1981年4月至1984年5月，就职于中国人民银行；</h3>
        <h3>　1984年5月至2005年11月，在中国工商银行海淀区办事处、海淀区支行、北京分行、数据中心（北京）等单位工作（期间，1995年12月至2005年11月任中国工商银行北京分行行长助理、副行长，1999年1月至2004年4月兼任中国工商银行数据中心（北京）总经理）；</h3>
        <h3>　2005年12月至2009年12月，任交通银行北京分行党委书记、行长；</h3>
        <h3>　2010年1月至2011年10月，任交通银行北京管理部副总裁兼交通银行北京分行党委书记、行长；</h3>
        <h3>　2011年10月，任中信银行党委副书记；</h3>

        <h3>　　2011年12月至2014年5月，任中信银行副行长；</h3>
        <h3>　2014年5月至2016年7月，任中信银行常务副行长；</h3>
        <h3>　2016年7月，任中信银行行长。（简历摘自中信银行网站）</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
     GoreportInternet() {
      this.$router.push("/Investigate");
    },
    GoreportEvaluation() {
      this.$router.push("/Investigate/DangJi" );
    },
  }
};
</script>

<style lang="less" scoped>
.si{
   margin: 0 16px;
 }
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.yi {
  margin-top: 20px;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
</style>